module.exports = __webpack_public_path__ + "static/media/background.90509407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/as/media/background.jpg
// module id = 891
// module chunks = 0